import { useState } from 'react';
import { IconButton } from '@chakra-ui/react';
import { LuUserRound } from 'react-icons/lu';
import { Tooltip } from '@components/ui/tooltip';

import ManageUsersDialog from './ManageUsersDialog';

type Props = {
  executionId: string;
};

const ManageUsersButton = ({ executionId }: Props) => {
  const [showManageUsersDialog, setShowManageUsersDialog] = useState(false);

  return (
    <>
      <Tooltip content="Alterar usuários" showArrow>
        <IconButton
          variant="ghost"
          color="argos.fg"
          onClick={() => setShowManageUsersDialog(true)}
        >
          <LuUserRound size={24} />
        </IconButton>
      </Tooltip>
      {showManageUsersDialog && (
        <ManageUsersDialog
          executionId={executionId}
          handleClose={() => setShowManageUsersDialog(false)}
        />
      )}
    </>
  );
};

export default ManageUsersButton;
